/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCompanyDetails } from '../fn/company/get-company-details';
import { GetCompanyDetails$Params } from '../fn/company/get-company-details';
import { updateCompany } from '../fn/company/update-company';
import { UpdateCompany$Params } from '../fn/company/update-company';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompanyDetails()` */
  static readonly GetCompanyDetailsPath = '/api/gmn/Company/getcompanydetails';

  /**
   * Get details for specific company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyDetails$Response(params?: GetCompanyDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getCompanyDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details for specific company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyDetails(params?: GetCompanyDetails$Params, context?: HttpContext): Observable<void> {
    return this.getCompanyDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCompany()` */
  static readonly UpdateCompanyPath = '/api/gmn/Company/updatecompany';

  /**
   * Update company informations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompany()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany$Response(params?: UpdateCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * Update company informations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompany$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany(params?: UpdateCompany$Params, context?: HttpContext): Observable<void> {
    return this.updateCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
